import { Component, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { TrpcAPIService } from '../../trpc-api.service';

@Component({
  selector: 'auth-badge',
  templateUrl: './badge.component.html',
  styleUrl: './badge.component.scss',
  providers: [
    {
      provide: 'i18n-label',
      useValue: 'BadgeComponent'
    }
  ]

})
export class BadgeComponent {
  constructor(public auth: AuthService, private router: Router, @Inject('ServerApi')public apiService: TrpcAPIService) { }

  loginWithRedirect() {
    this.auth.loginWithRedirect({
      appState: { target: this.router.url }
    });
  }

  logout() {
    this.auth.logout({ logoutParams: { returnTo: window.location.origin } });
  }


}
